import React, { useState, useEffect } from 'react';
import { Link as ScrollLink } from 'react-scroll';
import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation } from 'react-router-dom';
import '../styles/design-system.css';

const Navbar = () => {
    const { t, i18n } = useTranslation();
    const [isScrolled, setIsScrolled] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();

    const [isMenuOpen, setIsMenuOpen] = useState(false);

    // Change language
    const changeLanguage = (lng) => {
        i18n.changeLanguage(lng);
    };

    // Sticky header effect
    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 50) {
                setIsScrolled(true);
            } else {
                setIsScrolled(false);
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const navLinks = [
        { name: 'home', label: t('home') || 'Home' },
        { name: 'academic', label: t('academic') || 'Academic' },
        // { name: 'newsfeed', label: t('newsfeed') || 'News Feed' },
        { name: 'about', label: t('aboutUs') || 'About Us' },
        { name: 'contactus', label: t('contactUs') || 'Contact Us' },
    ];

    const handleNavClick = (section) => {
        setIsMenuOpen(false);
        if (location.pathname !== '/') {
            navigate('/');
            setTimeout(() => {
                // If needed, scroll logic here
            }, 100);
        }
    };

    return (
        <nav className={`navbar ${isScrolled ? 'scrolled' : ''}`} style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            zIndex: 1000,
            transition: 'all 0.3s ease',
            padding: isScrolled ? '15px 0' : '25px 0',
            background: isScrolled ? 'rgba(255, 255, 255, 0.95)' : 'transparent',
            boxShadow: isScrolled ? '0 4px 30px rgba(0, 0, 0, 0.1)' : 'none',
            backdropFilter: isScrolled ? 'blur(5px)' : 'none',
        }}>
            <div className="container" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div className="logo" onClick={() => window.scrollTo(0, 0)} style={{ cursor: 'pointer', zIndex: 1001 }}>
                    <h2 style={{ color: 'rgba(255, 153, 0, 1)', display: 'flex', alignItems: 'center', gap: '10px' }}>
                        SUN LANKA <span style={{ color: 'rgba(0, 0, 0, 1)', verticalAlign: 'bottom', fontSize: '20px' }}>Vocational</span>
                    </h2>
                </div>

                <ul className={`nav-menu ${isMenuOpen ? 'active' : ''}`}>
                    {navLinks.map((link) => (
                        <li key={link.name}>
                            <ScrollLink
                                activeClass="active"
                                to={link.name}
                                spy={true}
                                smooth={true}
                                offset={-40}
                                duration={800}
                                className="nav-link"
                                style={{
                                    color: isScrolled || isMenuOpen ? 'var(--color-charcoal)' : '#333',
                                    fontSize: '16px',
                                    fontWeight: 500
                                }}
                                onClick={() => handleNavClick(link.name)}
                            >
                                {link.label}
                            </ScrollLink>
                        </li>
                    ))}
                    {/* Mobile Menu Actions */}
                    <li className="mobile-only" style={{ display: isMenuOpen ? 'block' : 'none', marginTop: '10px' }}>
                        <div style={{ display: 'flex', gap: '10px', justifyContent: 'center' }}>
                            <button onClick={() => changeLanguage('en')} style={{ padding: '8px 16px', borderRadius: '20px', border: '1px solid #ccc', background: i18n.language === 'en' ? '#FFCB05' : '#fff' }}>EN</button>
                            <button onClick={() => changeLanguage('ja')} style={{ padding: '8px 16px', borderRadius: '20px', border: '1px solid #ccc', background: i18n.language === 'ja' ? '#FFCB05' : '#fff' }}>JP</button>
                        </div>
                    </li>
                </ul>

                <div className="actions" style={{ display: 'flex', gap: '20px', alignItems: 'center' }}>
                    <div style={{ display: 'flex', gap: '5px', background: 'rgba(0,0,0,0.05)', padding: '5px', borderRadius: '30px' }}>
                        <button
                            className="btn-lang"
                            onClick={() => changeLanguage('en')}
                            style={{
                                background: i18n.language === 'en' ? '#fff' : 'transparent',
                                border: 'none',
                                cursor: 'pointer',
                                fontWeight: i18n.language === 'en' ? 'bold' : 'normal',
                                borderRadius: '20px',
                                padding: '5px 12px',
                                boxShadow: i18n.language === 'en' ? '0 2px 5px rgba(0,0,0,0.1)' : 'none',
                                transition: 'all 0.3s'
                            }}
                        >
                            EN
                        </button>
                        <button
                            className="btn-lang"
                            onClick={() => changeLanguage('ja')}
                            style={{
                                background: i18n.language === 'ja' ? '#fff' : 'transparent',
                                border: 'none',
                                cursor: 'pointer',
                                fontWeight: i18n.language === 'ja' ? 'bold' : 'normal',
                                borderRadius: '20px',
                                padding: '5px 12px',
                                boxShadow: i18n.language === 'ja' ? '0 2px 5px rgba(0,0,0,0.1)' : 'none',
                                transition: 'all 0.3s'
                            }}
                        >
                            JP
                        </button>
                    </div>
                </div>

                {/* Hamburger Toggle */}
                <button className="mobile-menu-toggle" onClick={() => setIsMenuOpen(!isMenuOpen)} style={{ zIndex: 1001 }}>
                    ☰
                </button>
            </div>
        </nav>
    );
};

export default Navbar;
